import type { NotifyInterventionTransitionProps } from "./intervention-action-transition.type";

import { Trans } from "react-i18next";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";
import { BatchPreviewTransitionLink } from "@/modules/batch-preview/batch-preview-transition-link";
import { ModelLink } from "@/modules/model-link";
import { OrganizationContextLabel } from "@/modules/organization/organization-context-label";
import { StateTag } from "@/modules/state-tag";
import { UserAvatar } from "@/ui/user-avatar";

export const notifyInterventionTransition = ({
  notify,
  payload,
}: NotifyInterventionTransitionProps) => {
  const { context, event_type, user, state, interventions } = payload;
  const count = interventions.length;
  const ids = interventions.map(({ id }) => id);

  const onLinkClick = () => {
    notify.close(payload.id);
  };

  notify.info({
    key: payload.id,
    title: (
      <Trans
        i18nKey="notification:interventionTransition.description"
        values={{
          userName: user.name,
          interventionName: interventions[0]?.name ?? "",
          count,
        }}
        components={{
          StateTag: <StateTag value={state} type="intervention" asText />,
        }}
      />
    ),
    icon: (
      <UserAvatar
        size="small"
        statusColor="info"
        user={{ name: user.name }}
        withTooltip
      />
    ),
    actions: (
      <>
        {count === 1 ? (
          <ModelLink
            model="intervention"
            item={interventions[0]}
            showIcon
            modelAsName
            customContext={context}
            onClick={onLinkClick}
          />
        ) : (
          <BatchPreviewTransitionLink
            type={event_type}
            state={state}
            userId={user.id}
            ids={ids}
            customContext={context}
            onClick={onLinkClick}
            icon="model"
          />
        )}
        <OrganizationContextLabel context={context} isSmall />
      </>
    ),
    duration: ONE_MINUTE_IN_SECONDS,
  });
};
